export default __webpack_public_path__ + "static/media/custody.104c8492.svg";